import React, { useState, useEffect } from "react";
import "./Slideshow.css";
import ketkeshvarImage from "../assets/images/ketkeshvar3.JPG";
import ketkeshvarmandir from "../assets/images/ketkeshvar7.JPG";
import leaf from "../assets/images/leaf.jpg";

const slides = [
  {
    image: ketkeshvarImage,
    heading: "Ketkeshvar Yatra",
    description:
      "Experience the serene beauty of cascading water in lush forests.",
  },
  {
    image: leaf,
    heading: "Leaf Market (पान बाजार) – Every Tuesday",
    description:
      "The Leaf Market in Nimgoan Ketki, locally known as the पान बाजार, is held every Tuesday. It is dedicated to the wholesale and retail trade of betel leaves (paan), attracting traders and vendors from surrounding villages. Specialized market for fresh betel leaves. Supplies to local and regional vendors. Popular among farmers and traders dealing in cash crops. Located near the Gram Panchayat office.",
  },
  {
    image: ketkeshvarmandir,
    heading: "Shri Ketakeshwar Mahadev Mandir (श्री केतकेश्वर महादेव मंदिर)",
    description:
      "This sacred temple houses the ancient Shivalinga discovered in the Ketaki bushes. It is the heart of the village's spiritual heritage.",
  },
];

const Slideshow = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const goTo = (index) => setCurrent(index);
  const goPrev = () => setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  const goNext = () => setCurrent((prev) => (prev + 1) % slides.length);

  return (
    <div className="slideshow-container">
      <div className="slides-wrap">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`slide ${index === current ? "active" : ""}`}
          >
            <div className="slide-image">
              <img src={slide.image} alt={slide.heading} />
            </div>
            <div className="slide-text">
              <h2>{slide.heading}</h2>
              <p>{slide.description}</p>
            </div>
          </div>
        ))}

        <button className="slide-arrow prev" onClick={goPrev} aria-label="Previous slide" type="button">
          ‹
        </button>
        <button className="slide-arrow next" onClick={goNext} aria-label="Next slide" type="button">
          ›
        </button>
      </div>

      <div className="dots">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === current ? "active" : ""}`}
            onClick={() => goTo(index)}
            role="button"
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Slideshow;